import React from "react";
import MainLayout from "../../layout/MainLayout";
import CancerMainHeader from "../../layout/Header/CancerMainHeader";
import CancerMainFooter from "../../layout/Footer/CancerMainFooter";
import FormList from "./FormList";

// import Grid from "@material-ui/core/Grid";
// import Typography from "@material-ui/core/Typography";
// import Button from "@material-ui/core/Button";
// import clsx from "clsx";
// import {
//   prostate9yearCase,
//   prostateAgeChecker,
// } from "../../../utils/calculate";
// import { sexCheck } from "../../../utils/cancerCalView";
// import ProstateButton from "./ProstateButton";
// import PrintViewResult from "../../PrintViewResult";

const ProstateSubFormResult = ({
  onPageChange,
  onLinkHome,
  score,
  total,
  onChange,
  data,
}) => {
  // 다음으로 페이지 이동
  const handlePageMove = () => {
    onPageChange(4);
  };

  return (
    <MainLayout
      header={<CancerMainHeader cancer="전립선암" />}
      footer={<CancerMainFooter onClick1={handlePageMove} />}
    >
      <FormList
        onLinkHome={onLinkHome}
        score={score}
        total={total}
        onChange={onChange}
        data={data}
      />
    </MainLayout>
  );
};

export default ProstateSubFormResult;
